import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["fluid", "componentClass", "clsPrefix", "className"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  /**
   * Adds `container-fluid` class.
   */
  fluid: PropTypes.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
var defaultProps = {
  componentClass: 'div',
  fluid: false
};
var Con = (_dec = WebUI({
  name: "container",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Con, _React$Component);

  var _super = _createSuper(Con);

  function Con() {
    _classCallCheck(this, Con);

    return _super.apply(this, arguments);
  }

  _createClass(Con, [{
    key: "render",
    value: function render() {
      var _tbclass;

      var _this$props = this.props,
          fluid = _this$props.fluid,
          Component = _this$props.componentClass,
          clsPrefix = _this$props.clsPrefix,
          className = _this$props.className,
          others = _objectWithoutProperties(_this$props, _excluded);

      var tbclass = (_tbclass = {}, _defineProperty(_tbclass, "".concat(clsPrefix), !fluid), _defineProperty(_tbclass, "".concat(clsPrefix, "-fluid"), fluid), _tbclass);
      return /*#__PURE__*/React.createElement(Component, _extends({}, others, {
        className: classNames(tbclass, className)
      }), this.props.children);
    }
  }]);

  return Con;
}(React.Component)) || _class);
Con.propTypes = propTypes;
export default Con;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-layout/src/Container.js